import {Injectable} from '@angular/core';
import {BackendService} from "./backend.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {ResponseDto} from "../dto/response.dto";

interface CountryCode {
    country: string;
    code: string;
}

@Injectable({
    providedIn: 'root'
})
export class PublicService {
    urlPrefix = '/api/public';

    constructor(private backend: BackendService) {
    }

    getLatestProperty(): Observable<any> {
        return this.backend.get(`${this.urlPrefix}/property/latest`).pipe(
            map(response => response.response)
        );
    }

    getSegmentList(): Observable<any> {
        const url = `${this.urlPrefix}/segment/list`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }

    getOffersList(segmentId:any): Observable<any> {
        const url = `${this.urlPrefix}/ad/list/segment/${segmentId}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }
    getDepartmentCityList(departmentCode: string): Observable<any> {
        const url = `${this.urlPrefix}/city/list/department/${departmentCode}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }
    getZoneList(cityCode: string): Observable<any> {
        const url = `${this.urlPrefix}/zone/list/city/${cityCode}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }

    getCatalogList(catalogCode: string): Observable<any> {
        const url = `${this.urlPrefix}/option/list/${catalogCode}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }
    getCatalogOptionList(catalogCode: string, optionCode: string): Observable<any> {
        const url = `${this.urlPrefix}/${catalogCode}/option/${optionCode}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }
}
